import { axiosInstance } from './api';
import * as ActionTypes from '../store/ActionTypes';

export const actionCreators = {
    getPromoCode: (promoCode) => ({ type: ActionTypes.getPromoCode, payload: promoCode }),
    updateResponse: (response) => ({ type: ActionTypes.updateResponse, payload: response }),
}

export const getPromoCodePaginated = (filter, pageNumber, pageSize, orderBy, descending, onlyActive) => {
    const url = `PromoCode/GetPromoCodesByFilterPaginatedAsync?filter=${filter}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&descending=${descending}&onlyActive=${onlyActive}`;
    return axiosInstance().get(url);
}

export const getPromoCode = (id) => {
    return dispatch => {
        const url = `PromoCode/GetPromoCodeById/${id}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getPromoCode({
                ...response.data.data,
                enrollFeeWaived: response.data.data.enrollFeePromoTypeCode === 'WA' ? response.data.data.enrollFeePercentage : '',
                enrollFeePercentage: response.data.data.enrollFeePromoTypeCode === 'WA' ? '' : response.data.data.enrollFeePercentage
            }
            ))
        }).catch(response => dispatch(actionCreators.updateResponse(response.response)));
    }
}

export const createPromoCode = (promoCode) => {
    return dispatch => {
        const url = `PromoCode/PostAsync`;
        return axiosInstance().post(url, promoCode).then(response => {
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => dispatch(actionCreators.updateResponse(response.response)));
    }
}

export const updatePromoCode = (promoCode) => {
    return dispatch => {
        const url = `PromoCode/PutAsync`;
        return axiosInstance().put(url, promoCode).then(response => {
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => dispatch(actionCreators.updateResponse(response.response)));
    }
}

export const updateResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateResponse(response));
    }
}